module.exports = __webpack_public_path__ + "front/img/p1.9843cfd5.png";